import i18next from "i18next";
import { setLanguage as setElementUiLanguage } from "./elementUiLanguage";
import LanguageDetector from "i18next-browser-languagedetector";
import { MandaaWebpackBackend } from "./webpackBackend";
import Backend from "i18next-chained-backend";
import XHR from "i18next-xhr-backend";

i18next.use(Backend);
i18next.use(LanguageDetector);
(async function() {
  await i18next.init({
    load: "languageOnly",
    supportedLngs: ["en", "es"],
    initImmediate: true,
    fallbackLng: "es",
    backend: {
      backends: [MandaaWebpackBackend, XHR],
      backendOptions: [
        {
          context: require.context(
            "../../public/assets/locales",
            true,
            /\.json$/,
            "lazy"
          ),
        },
        { loadPath: "/assets/locales/{{lng}}/{{ns}}.json" },
      ],
    },
    ns: [
      "auth",
      "buttons",
      "dashboard",
      "landing",
      "invoices",
      "receiver",
      "sender",
      "contact",
      "cookiesPolicy",
      "plan",
      "units",
      "settings",
      "router",
      "validationRules",
      "invoiceDeliveryError",
      "metrics"
    ],
    detection: {
      order: ["navigator"],
    },
  });
  await setElementUiLanguage(i18next);
}());

export default i18next;
